var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"echarts",attrs:{"id":'echarts-' + _vm.index}}),_c('div',{staticStyle:{"text-align":"center","font-size":"14px"}},[_vm._v(" "+_vm._s(_vm.hasMore ? "左滑加载更多数据" : "没有更多")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }